var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M17.2487 24C16.474 24 15.7058 23.863 14.9547 23.5901C11.6455 22.388 8.57396 20.4301 6.07187 17.9281C3.56979 15.4261 1.6119 12.3544 0.409838 9.04529C0.0235567 7.98183 -0.0904387 6.88406 0.0711328 5.78236C0.222486 4.7504 0.62222 3.74858 1.22716 2.88518C1.83478 2.01798 2.64484 1.2967 3.56974 0.799327C4.55604 0.268958 5.63258 0 6.76953 0C7.12314 0 7.42875 0.247068 7.50286 0.592804L8.68003 6.08628C8.73333 6.33504 8.65687 6.59387 8.47702 6.77377L6.46556 8.78519C8.36307 12.5578 11.4421 15.6368 15.2147 17.5343L17.2261 15.5229C17.406 15.343 17.6649 15.2667 17.9136 15.3199L23.4071 16.497C23.7529 16.5711 23.9999 16.8767 23.9999 17.2304C23.9999 18.3673 23.7309 19.4439 23.2005 20.4302C22.7031 21.3551 21.9819 22.1652 21.1147 22.7728C20.2513 23.3777 19.2495 23.7774 18.2175 23.9288C17.8941 23.9763 17.5708 24 17.2487 24Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneFilled);
export default __webpack_public_path__ + "static/media/phone-filled.da87fb6fa7ca4ad7d65e1c7e9feff39f.svg";
export { ForwardRef as ReactComponent };